import { useState } from "react";
import { FormInput } from "../Component/FormInput";
import Name from "../assets/firstName.png";
import Phone from "../assets/Phone.png";
import { useFormData } from "../Context/FormContext";

export const EmergencyContact = ({ errors: externalErrors, setErrors: externalSetErrors }) => {
  const { formData, setFormData } = useFormData();
  const [localErrors, setLocalErrors] = useState({});
  const errors = externalErrors ?? localErrors;
  const setErrors = externalSetErrors ?? setLocalErrors;

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "emergencyContactFirstName":
        if (!value.trim()) {
          error = "This field is required";
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          error = "Only letters are allowed";
        }
        break;

      case "emergencyContactRelationship":
        if (!value.trim()) {
          error = "Relationship is required";
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          error = "Only letters are allowed in relationship";
        }
        break;

      case "emergencyContactPhoneNumber":
        if (!value.trim()) {
          error = "Emergency contact phone number is required";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;
    setFormData((prev) => ({
      ...prev,
      emergencyDetails: { ...prev.emergencyDetails, [name]: newValue },
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, newValue),
    }));
  };

  return (
    <div className="contents">
        <div className="space-y-2 mt-2">
          <FormInput
            label="Emergency Contact Name"
            placeholder="Enter Contact name..."
            name="emergencyContactFirstName"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactFirstName || ""}
            icon={Name}
          />
          {errors.emergencyContactFirstName && (
            <p className="text-red-500 text-sm">{errors.emergencyContactFirstName}</p>
          )}
        </div>

        <div className="space-y-2 mt-2">
          <FormInput
            label="Relationship"
            placeholder="Enter relationship..."
            name="emergencyContactRelationship"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactRelationship || ""}
            icon={Name}
          />
          {errors.emergencyContactRelationship && (
            <p className="text-red-500 text-sm">{errors.emergencyContactRelationship}</p>
          )}
        </div>

        <div className="space-y-2 mt-2">
          <FormInput
            label="Emergency Contact Phone Number"
            placeholder="(000) 000-0000"
            name="emergencyContactPhoneNumber"
            onChange={handleChange}
            value={formData.emergencyDetails.emergencyContactPhoneNumber || ""}
            icon={Phone}
            onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
          />
          {errors.emergencyContactPhoneNumber && (
            <p className="text-red-500 text-sm">{errors.emergencyContactPhoneNumber}</p>
          )}
        </div>
    </div>
  );
};
